module.exports = __webpack_public_path__ + "static/media/slider_porque_icon9.04142a7d.svg";